import { fun_PostAction, fun_GetAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 提示弹窗
      dialogVisible: false,
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        corpName: null, // 企业名称
        personName: null, // 项目负责人名称
        auditState: null // 核验状态
      },
      // 查询表单
      formSearchList: [
        // {
        //   type: "input",
        //   label: "企业名称：",
        //   value: "corpName",
        //   placeholder: "请输入",
        //   clearable: true
        // },
        {
          type: "input",
          label: "姓名：",
          value: "personName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "核验状态：",
          value: "auditState",
          placeholder: "请输入",
          clearable: true,
          optionData: [
            { name: "保存", value: "bc" },
            { name: "提交", value: "tj" },
            { name: "通过", value: "tg" },
            { name: "退回", value: "th" }
          ]
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "personName",
          isShow: true
        },
        {
          label: "网上CA资料申报",
          slotName: "declare",
          width: "140"
        },
        {
          label: "所属企业",
          prop: "corpName"
        },
        {
          label: "身份证号",
          prop: "idCard"
        },
        {
          label: "状态",
          slotName: "auditState",
          width: 100
        },
        {
          label: "异动状态",
          slotName: "state",
          width: 100
        },
        {
          label: "性别",
          prop: "sexNum",
          width: 80
        },
        {
          label: "手机号码",
          prop: "mobile"
        }
      ],
      // 表格数据
      tableData: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      loginType: sessionStorage.getItem("loginType"), // 登录角色id
      userType: sessionStorage.getItem("userType"), // 用户类型
      multipleSelection: [], // 勾选数组
      // 温馨提示
      tipList: [
        /* {
         type: "text",
         text: "转入”和“转出”需要企业（市场主体）与项目负责人双方同意！",
       },*/
      ],
      // 弹窗初始状态
      personDialogVisible: false,
      // 身份证号
      idCard: null
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 获取用户信息
    this.fun_GetUser();
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取用户信息
     * @returns {Promise<void>}
     */
    async fun_GetUser() {
      // 如果用户类型是注册用户或者用户标识是工作人员或者监管人员
      if (
        "201508061647510026" == this.userType ||
        "工作人员" == this.userFlag ||
        "监管人员" == this.userFlag
      ) {
        // 存在数量
        let num = 0;
        // 遍历查询表单
        this.tableColumns.forEach(e => {
          // 如果是企业名称
          if (e.prop === "corpName") {
            num++;
          }
        });
        // 不存在企业名称
        if (num == 0) {
          // 定义所属企业
          let corpName = {
            label: "所属企业",
            prop: "corpName"
          };
          // 将所属企业加入表单首位
          this.tableColumns.splice(0, 0, corpName);
        }
        let opt = {
          label: "操作",
          slotName: "operation",
          width: 100
        };
        this.tableColumns.splice(this.tableColumns.length, 0, opt);
        // 设置表头
        this.btnList = [
          {
            name: "新增",
            type: "success",
            icon: "document-add"
          }
        ];
      }
      // 如果是注册用户
      if ("注册用户" == this.userFlag) {
        // 如果是企业
        if ("201508061647340018" == this.userType) {
          // 设置表头
          this.btnList = [
            // {
            //   name: "添加",
            //   type: "success",
            //   icon: "document-add"
            // },
            {
              name: "修改",
              type: "primary",
              icon: "edit"
            },
            {
              type: "slot",
              slotName: "shiftTo"
            },
            {
              type: "slot",
              slotName: "voluntarily"
            },
            {
              type: "slot",
              slotName: "rollOut"
            },
            {
              type: "slot",
              slotName: "tit"
            }
          ];
          // 遍历查询表单
          this.formSearchList.forEach(e => {
            // 如果是企业名称
            if (e.value === "corpName") {
              e.disabled = true; // 置灰
            }
          });
          // 设置企业名称
          // this.form.corpName = data.zsxm;
        }
        // 如果是注册人员
        else if ("201508061647510026" == this.userType) {
          // 设置表头
          this.btnList = [
            {
              name: "完善资料",
              type: "primary",
              icon: "edit"
            },
            {
              type: "slot",
              slotName: "shiftTo"
            },
            {
              type: "slot",
              slotName: "rollOut"
            },
            {
              type: "slot",
              slotName: "cancel"
            }
          ];
          // 清空表单查询
          this.formSearchList = [];
        }
      }
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(
          "/regPersonBasicinfo/list",
          {
            ...this.form,
            ...this.reqPageData
          },
          0
        );
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        // case "添加":
        //   this.fun_Add();
        //   break;
        case "修改":
          this.fun_Edit();
          break;
        case "转入":
          this.fun_Join();
          break;
        case "自动转入":
          this.fun_AutoJoin();
          break;
        case "转出":
          this.fun_RollOut();
          break;
        case "什么是项目负责人信息？":
          this.fun_Help();
          break;
        case "完善资料":
          this.fun_MyUpdate();
          break;
        case "异动撤回":
          this.fun_PersonBackRollOut();
          break;
        case "新增":
          this.personDialogVisible = true;
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 核验状态
      if (i === "auditState") {
        // 赋值
        this.form.auditState = e;
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 判断是否为工作人员
      if (
        sessionStorage.getItem("userFlag") === "工作人员" ||
        sessionStorage.getItem("userType") === "201508061647510026"
      ) {
        // 跳转详情页面
        this.$router.push({
          path: "/regPersonBasicinfoDetail",
          query: {
            type: "details",
            id: e.val.id
          }
        });
        return false;
      }
      // 子传父
      this.$emit("fun_Details", "regPersonBasicinfoDetails", {
        id: e.val.id,
        type: "details"
      });
    },
    // /**
    //  * 点击新增按钮
    //  */
    // fun_Add() {
    //   // 子传父
    //   this.$emit("fun_Details", "regPersonBasicinfoDetails", {
    //     type: "insert"
    //   });
    // },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 子传父
          this.$emit("fun_Details", "regPersonBasicinfoDetails", {
            id: this.multipleSelection[0].id,
            type: "update"
          });
        }
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 完善资料
     */
    fun_MyUpdate() {
      // 判断是否为注册人员
      if (sessionStorage.getItem("userType") === "201508061647510026") {
        // 跳转详情页面
        this.$router.push({
          path: "/regPersonBasicinfoDetail",
          query: {
            type: "update",
            id: this.tableData[0].id
          }
        });
        return false;
      }
      // 子传父
      this.$emit("fun_Details", "regPersonBasicinfoDetails", {
        id: this.tableData[0].id,
        type: "update"
      });
    },
    /**
     * 转入
     */
    fun_Join() {
      // 如果是企业
      if ("201508061647340018" == this.userType) {
        // 子传父
        this.$emit("fun_Details", "/regPersonBasicinfoUnChoose", {});
      }
      // 如果是注册人
      else if ("201508061647510026" == this.userType) {
        // 判断条数是否大于0
        if (this.tableData && this.tableData.length > 0) {
          // 如果项目负责人状态不是正常
          if (this.tableData[0].state != "0") {
            this.$alert(
              "该项目负责人状态为异动中，无法进行转入转出操作！",
              "warning"
            );
            return;
          }
          // 如果所属企业不为空
          if (
            this.tableData[0].corpId != "" &&
            this.tableData[0].corpId != null
          ) {
            this.$alert(
              "该项目负责人有所属企业，无法进行再次转入操作！",
              "warning"
            );
            return;
          }
          // 跳转详情页面
          this.$router.push({
            path: "/regPersonBasicinfoUnCorpChoose",
            query: {}
          });
        }
        // 如果未进行勾选
        else {
          // 提示，并清除选中数据
          this.$alert("最少选择一条数据！", "warning");
        }
      }
    },
    /**
     * 自动转入
     */
    fun_AutoJoin() {
      // 子传父
      this.$emit("fun_Details", "/regPersonBasicinfoAutoChoose", {});
    },
    /**
     * 转出
     */
    fun_RollOut() {
      // 主键集合
      let keys = [];
      // 如果是企业
      if ("201508061647340018" == this.userType) {
        // 判断是否勾选
        if (this.multipleSelection && this.multipleSelection.length > 0) {
          // 遍历勾选
          for (const index in this.multipleSelection) {
            // 赋值主键集合
            keys[index] = this.multipleSelection[index].id;
          }
          // 弹出询问confirm
          this.$confirm("确认要将此项目负责人转出？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 请求，获取结果集
            fun_PostAction("/regPersonBasicinfoChoose/updateUnRegPerson", {
              keys: keys,
              controllerFlg: "update" // 转出
            }).then(res => {
              // 解构res.data
              const { msg } = res.data;
              this.$alert(msg);
              // 获取用户信息
              this.fun_GetUser();
              // 查询一览数据
              this.fun_GetList();
            });
          });
        }
        // 未勾选
        else {
          this.$alert("请至少选择一条项目负责人转出数据！", "warning");
          return;
        }
      }
      // 如果是注册人
      else if ("201508061647510026" == this.userType) {
        // 判断条数是否大于0
        if (this.tableData && this.tableData.length > 0) {
          // 如果项目负责人状态不是正常
          if (this.tableData[0].state != "0") {
            this.$alert(
              "该项目负责人状态为异动中，无法进行转入转出操作！",
              "warning"
            );
            return;
          }
          // 如果所属企业为空
          if (
            this.tableData[0].corpId == "" ||
            this.tableData[0].corpId == null
          ) {
            this.$alert(
              "该项目负责人无所属企业，无法进行转出操作！",
              "warning"
            );
            return;
          }
          // 弹出询问confirm
          this.$confirm("确认要将此项目负责人转出？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 请求，获取结果集
            fun_PostAction("/regPersonBasicinfoChoose/updateOutCorp", {
              id: this.tableData[0].id,
              controllerFlg: "update" // 转出
            }).then(res => {
              // 解构res.data
              const { msg } = res.data;
              this.$alert(msg);
              // 获取用户信息
              this.fun_GetUser();
              // 查询一览数据
              this.fun_GetList();
            });
          });
        }
        // 未勾选
        else {
          this.$alert("请先将项目负责人基本信息补充完整！", "warning");
          return;
        }
      }
    },
    /**
     * 什么是项目负责人信息？
     */
    fun_Help() {
      // 打开弹窗
      this.dialogVisible = true;
    },
    /**
     * 异动撤回
     */
    fun_PersonBackRollOut() {
      // 判断条数是否大于0
      if (this.tableData && this.tableData.length > 0) {
        // 如果项目负责人状态是正常
        if (this.tableData[0].state == "0") {
          this.$alert(
            "该项目负责人没有异动记录，无法进行异动撤回操作！",
            "warning"
          );
          return;
        }
        // 弹出询问confirm
        this.$confirm("确认要撤回此项目负责人异动？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("regPersonBasicinfo/revokeInfo", {
            id: this.tableData[0].id // 主键
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            this.$alert(msg);
            // 获取用户信息
            this.fun_GetUser();
            // 查询一览数据
            this.fun_GetList();
          });
        });
      }
      // 未勾选
      else {
        this.$alert("请先将项目负责人基本信息补充完整！", "warning");
        return;
      }
    },
    /**
     * 进入网上CA申报资料详情
     * @author shuhua
     */
    fun_GoDeclare(e) {
      // 核验状态等于通过
      if (e.auditState === "tg") {
        // 判断是注册人
        if (
          sessionStorage.getItem("userType") === "201508061647510026" ||
          sessionStorage.getItem("userFlag") === "工作人员"
        ) {
          // 跳往网上CA资料申报信息
          this.$router.push({
            path: "/userDeclare",
            query: {
              id: e.id,
              flag: "1"
            }
          });
        } else {
          // 跳转到网上CA资料申报信息详情
          this.$emit("fun_Details", "/declare", { id: e.id, flag: "1" });
        }
      } else {
        // 错误消息提示
        this.$alert(
          "只有项目负责人通过才能进行项目负责人Ca资料申报！",
          "warning"
        );
      }
    },
    /**
     * 弹窗关闭
     */
    fun_Close() {
      // 清空
      this.idCard = null;
    },
    /**
     * @description 更新企业信息
     * @author
     */
    fun_Update(e) {
      // 身份证号
      this.idCard = e.idCard;
      // 同步数据
      this.fun_Sync();
    },
    /**
     * @description 同步注册人员信息
     * @author
     */
    fun_Sync() {
      // shifou
      if (!this.idCard) {
        //
        this.$message.error("请输入注册人员身份证号");
        return;
      }
      // 询问框
      this.$confirm("确定同步【" + this.idCard + "】注册人员信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 打开遮罩
        this.loading = true;
        // 发起请求
        fun_PostAction("/regPersonBasicinfo/synchronousPersonInfo", {
          idCard: this.idCard
        }).then(res => {
          // 结构res.data
          const { result, msg } = res.data;
          // 请求成功
          if (result) {
            // 关闭弹窗
            this.dialogVisible = false;
            // 清空
            this.idCard = null;
            // 提示消息
            this.$message.success(msg);
          } else {
            // 提示请求失败的信息
            this.$message.error(msg);
          }
          // 关闭遮罩层
          this.loading = false;
        });
      });
    }
  }
};
